import { LinearOptimizationType } from '@blisspointmedia/bpm-types/dist/OptimizationConstraints';

export const ROUTES = {
  CONSTRAINTS: {
    key: 'constraints',
    label: 'Constraints',
    uri: 'constraints',
    depth: 1
  },
  OPTIMIZATIONS: {
    key: 'optimizations',
    label: 'Optimizations',
    uri: 'optimizations'
  },
  RUNS: {
    key: 'runs',
    label: 'Runs',
    uri: 'runs',
    depth: 1
  }
} as const;

export const RUN_TABS = {
  SUMMARY: 'summary',
  BUYABLE_SPOTS: 'buyable-spots',
  CONSTRAINT_DEBUGGER: 'constraint-debugger'
} as const;
export type RunTabType = (typeof RUN_TABS)[keyof typeof RUN_TABS];

export const OptimizationType = {
  BUYING: 'buying',
  TRAFFIC: 'traffic',
  AUDIENCE: 'audience'
} as const;

// Optimization types are stored lowercase; these are the display labels.
export const OPTIMIZATION_TYPE_LABELS: Record<LinearOptimizationType, string> = {
  [OptimizationType.BUYING]: 'Buying',
  [OptimizationType.TRAFFIC]: 'Traffic',
  [OptimizationType.AUDIENCE]: 'Audience'
};

// Narrows the shared ConstraintFormModal's generic `string` optimizationType (it only knows about
// the Record<string,string> of options it was given) back to Linear's own type union.
export const isOptimizationType = (value: string): value is LinearOptimizationType =>
  (Object.values(OptimizationType) as string[]).includes(value);

// Stored as an id on the constraint record; these are the display labels.
export const OPTIMIZATION_TYPE_MAP: Record<number, LinearOptimizationType> = {
  1: OptimizationType.BUYING,
  2: OptimizationType.TRAFFIC,
  3: OptimizationType.AUDIENCE
};

export interface LinearOptimizationPageProps {
  company: string;
}

export interface Optimization {
  build_number: string;
  company_id: string;
  status: string;
  progress?: number;
  date: string;
  // CloudWatch log time-range bounds for this run, used by the Logs modal's log-group filters.
  start: string;
  end: string;
  constraint_name: string;
  objective_value?: number;
  cost?: number;
  budget?: number;
  branch: string;
}

export interface ConstraintListElement {
  name: string;
  lastmodified: string;
  optimizationType: LinearOptimizationType;
  week?: string;
}

export const StageTwoJobsStatus = {
  DISABLED: 'disabled',
  MISSING_MLDIAGNOSTICS: 'missing_mldiagnostics',
  OK: 'ok'
} as const;
export type StageTwoJobsStatusType = (typeof StageTwoJobsStatus)[keyof typeof StageTwoJobsStatus];

export interface StageTwoJobsInitiated {
  status: StageTwoJobsStatusType;
  kpi?: string;
}

export const ConstraintModalMode = {
  NEW: 'new',
  COPY: 'copy',
  DELETE: 'delete',
  RUN: 'run'
} as const;
export type ConstraintModalModeType =
  (typeof ConstraintModalMode)[keyof typeof ConstraintModalMode];

export interface CopyConstraintParams {
  from: string;
  to: string;
  optimizationType?: LinearOptimizationType;
  week?: string;
}

export interface NewConstraintParams {
  to: string;
  optimizationType?: LinearOptimizationType;
  week?: string;
}

export interface DeleteConstraintParams {
  deleteConstraintId: string;
}

export interface RunOptimizationParams {
  name: string;
  kpi: string;
  branch: string;
  optimizationType?: LinearOptimizationType;
  week?: string;
}
